<template>
  <div class="new-products c-layout" v-if="adv1 || adv2 || adv3 || adv4">
    <div class="new-products--right" v-if="adv1">
      <div class="img-desc">
        <p class="tx1 pos-y">{{ adv1.title }}</p>
        <p class="tx2 pos-y">{{ adv1.subtitle }}</p>
        <button class="desc-btn" v-show="adv1.linkurl" @click="handleBlockClick(adv1.linkurl)">{{ $t('btns.now_check') }}</button>
      </div>
      <!-- <img src="./images/JET_1377@2x.png" alt /> -->
      <img :src="adv1.path" alt="" @click="handleBlockClick(adv1.linkurl)">
    </div>

    <div class="new-products--left">
      <div class="item-top" v-if="adv2">
        <div class="first img-block">
          <picture>
            <!-- <source srcset="./images/0dsfsdf1_03-mobile.png" media="(max-width: 992px)"> -->
            <!-- <img src="./images/0dsfsdf1_03.png" /> -->
            <img :src="adv2.path" alt="" @click="handleBlockClick(adv2.linkurl)">
          </picture>
        </div>
        <div class="second img-block" v-if="adv3">
          <!-- <div class="img-desc show-on-pad">
            <p class="tx1 t-shadow">秋季飨宴</p>
            <p class="tx2 t-shadow">夏日推荐</p>
            <button class="desc-btn t-shadow">立即查看</button>
          </div> -->
          <picture>
            <!-- <source srcset="./images/DSC_0589-1@2x-mobile.png" media="(max-width: 992px)"> -->
            <!-- <img src="./images/DSC_0589-1@2x.png"/> -->
            <img :src="adv3.path" alt="" @click="handleBlockClick(adv3.linkurl)">
          </picture>
        </div>
      </div>
      <div class="item-bottom" v-if="adv4">
        <div class="img-desc">
          <p class="tx1 pos-y">{{ adv4.subtitle }}</p>
          <button class="desc-btn" v-show="adv4.linkurl" @click="handleBlockClick(adv4.linkurl)">{{ $t('btns.now_check') }}</button>
        </div>
        <picture>
          <!-- <source srcset="./images/1822@2x-mobile.png" media="(max-width: 992px)">
          <img class="img-responsive" src="./images/1822@2x.png" alt /> -->
          <img :src="adv4.path" alt="" @click="handleBlockClick(adv4.linkurl)">
        </picture>
      </div>
    </div>
  </div>
</template>

<script>
import { getHomeAdv } from '../../../../api'
export default {
  props: {
    adv: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      // adv1: '',
      // adv2: '',
      // adv3: '',
      // adv4: ''
    };
  },
  computed: {
    adv1() {
      return this.adv[0] ? this.adv[0]:'';
    },
    adv2() {
      return this.adv[1] ? this.adv[1]:'';
    },
    adv3() {
      return this.adv[2] ? this.adv[2]:'';
    },
    adv4() {
      return this.adv[3] ? this.adv[3]:'';
    }
  },
  async created() {
    const blockArr = [];
    // const adv1 = await getHomeAdv({ loc: 'adv1', count: 1 });
    // const adv2 = await getHomeAdv({ loc: 'adv2', count: 1 });
    // const adv3 = await getHomeAdv({ loc: 'adv3', count: 1 });
    // const adv4 = await getHomeAdv({ loc: 'adv4', count: 1 });

    // this.adv1 = adv1.status==='ok'?adv1.adv[0]:'';
    // this.adv2 = adv2.status==='ok'?adv2.adv[0]:'';
    // this.adv3 = adv3.status==='ok'?adv3.adv[0]:'';
    // this.adv4 = adv4.status==='ok'?adv4.adv[0]:'';
    console.log('****************************');
    console.log(this.adv);
    console.log('****************************');
    // this.adv1 = this.adv[0] ? this.adv[0]:'';
    // this.adv2 = this.adv[1] ? this.adv[1]:'';
    // this.adv3 = this.adv[2] ? this.adv[2]:'';
    // this.adv4 = this.adv[3] ? this.adv[3]:'';
    
  },
  mounted() {},
  methods: {
    handleBlockClick(link) {
      if(!link) return;
      // window.open(link, '_blank');
      // location.href = link;
      this.linkToRouter(link);
    }
  },
  components: {},
};
</script>

<style scoped lang='less'>
.new-products {
  display: flex;
  margin-top: 48px;
  margin-bottom: 48px;
  height: 536px;
  .desc-btn {
    cursor: pointer;
    width: 105px;
    height: 34px;
    background: var(---unnamed-color-ec4f00) 0% 0% no-repeat padding-box;
    box-shadow: 0px 3px 6px #00000029;
    opacity: 1;

    font-weight: lighter;
    font-size: 13px;
    color: var(--unnamed-color-ffffff);
  }
  .new-products--right {
    position: relative;
    width: 540px;
    height: 536px;
    margin-right: 30px;
    overflow: hidden;
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
    .img-desc {
      position: absolute;
      top: 105px;
      left: 65px;
      .tx1 {
        height: 45px;
        font-weight: 700;
        font-size: 30px;
        line-height: 45px;
        color: var(--unnamed-color-111111);
      }
      .tx2 {
        height: 78px;
        font-weight: 700;
        font-size: 53px;
        line-height: 78px;
        color: var(--unnamed-color-111111);
      }
    }
  }
  .new-products--left {
    .item-top {
      display: flex;
      margin-bottom: 30px;
      .img-block {
        width: 255px;
        height: 236px;
        overflow: hidden;
      }
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        object-position: 50% 50%;
      }
      .first {
        margin-right: 30px;
      }
    }
    .item-bottom {
      position: relative;
      width: 540px;
      height: 270px;
      overflow: hidden;
      .img-desc {
        position: absolute;
        left: 239px;
        top: 93px;
        .tx1 {
          display: block;
          text-align: right;
          height: 38px;

          font-weight: 500;
          font-size: 26px;

          color: var(--unnamed-color-ffffff);
          text-shadow: 0px 3px 6px var(---unnamed-color-707070);
        }
        .desc-btn {
          margin-top: 19px;
          margin-left: 126px;
        }
      }
    }
  }
}
img {
  display: block;
}
@media (max-width: 992px) {
  .new-products {
    flex-direction: column;
    margin-top: 10px;
    height: auto;
    .new-products--right {
      width: 100%;
      height: auto;
      .img-desc {
        top: unset;
        bottom: 40px;
        left: 20px;
        .tx1 {
          font-size: 1.3rem;
          line-height: 1.3rem;
          margin-bottom: 15px;
          height: auto;
        }
        .tx2 {
          font-size: 2.2rem;
          line-height: 2.2rem;
          margin-bottom: 20px;
          height: auto;
        }
      }
    }
    .new-products--left {
      margin-top: 10px;
      .item-top {
        flex-direction: column;
        margin-bottom: 10px;
        .img-block {
          width: 100%;
          padding-top: calc(100%/255*236);
          height: 0;
          position: relative;
        }
        img {
          position: absolute;
          top: 0%;
          left: 0;
        }
        .first {
          margin-right: 0;
          padding-top: calc(100%/435*162);
          // img{
          //   width: 100%;
          //   height: auto;
          // }
        }
        .second {
          padding-top: calc(100%/435*162);
          position: relative;
          .img-desc {
            position: absolute;
            bottom: 21px;
            right: 10px;
            z-index: 1;
            p {
              color: white;
              margin-bottom: 8px;
              text-align: right;
            }
            .tx1 {
              font-size: 16px;
            }
            .tx2 {
              font-weight: 500;
              font-size: 26px;
            }
          }
          img {
            margin-top: 10px;
            // width: 100%;
            // height: auto;
          }
        }
      }
      .item-bottom {
        width: 100%;
        height: 0;
        padding-top: calc(100%/540*270);
        .img-desc {
          left: unset;
          right: 10px;
        }
        .desc-btn {
          margin-top: 0 !important;
        }
        img {
          width: 100%;
          position: absolute;
          top: 0;
          left: 0;
          z-index: -1;
        }
      }
    }
  }
}
</style>
